<template>
  <Dialog
    :title="title"
    :visible="visible"
    maxWidth="580"
    @close="close"
  >
    <div>
      <v-card-text class="dialog__body">
        <div v-if="browser === 'not supported'">
          <p>{{ $t(`${namespace}.notSupportedText`) }}</p>
          <ul class="browser-list">
            <li>
              <a href="https://www.google.com/intl/pt-BR/chrome/" title="Google Chrome">
                <img src="./img/chrome.svg" alt="">
                <span>Google Chrome</span>
              </a>
            </li>

            <li>
              <a href="https://www.mozilla.org/pt-BR/firefox/" title="Mozilla Firefox">
                <img src="./img/firefox.svg" alt="">
                <span>Mozilla Firefox</span>
              </a>
            </li>

            <li>
              <a href="https://www.microsoft.com/pt-br/edge" title="Microsoft Edge">
                <img src="./img/internet-explorer.svg" alt="">
                <span>Microsoft Edge</span>
              </a>
            </li>
          </ul>
        </div>

        <p v-else class="pb-2">{{ $t(`${namespace}.outdatedBrowserText`) }}</p>
      </v-card-text>

      <v-divider />

      <v-card-actions v-if="browser === 'not supported'" class="dialog__footer">
        <v-spacer />
        <v-btn
          color="primary"
          rounded
          depressed
          @click.native="close"
        >
          {{ $t('Common.close') }}
        </v-btn>
      </v-card-actions>

      <v-card-actions v-else class="dialog__footer">
        <v-spacer />

        <a class="accent--text mr-4" @click.prevent="close">
          {{ $t('Common.cancel') }}
        </a>

        <v-btn
          color="primary"
          rounded
          depressed
          @click="updateBrowser"
        >
          <span v-html="$t(`${namespace}.proceed`).replace('[VAL]', `<span class='text--capitalize'>${browser}</span>`)" />
        </v-btn>
      </v-card-actions>
    </div>
  </Dialog>
</template>

<script>
import { detect } from 'detect-browser'

export default {
  name: 'BrowserCompatibilityDialog',
  computed: {
    browserInfo: () => detect(),

    title () {
      return this.browser === 'not supported'
        ? this.$t(`${this.namespace}.notSupportedTitle`)
        : this.$t(`${this.namespace}.outdatedBrowserTitle`)
    }
  },
  data () {
    return {
      namespace: 'Components.BrowserCompatibilityDialog',
      visible: false,
      browser: null,
      ver: null
    }
  },
  methods: {
    updateBrowser () {
      if (this.browser === 'chrome') {
        location.href = 'https://www.google.com/intl/pt-BR/chrome/'
      }

      if (this.browser === 'firefox') {
        location.href = 'https://www.mozilla.org/pt-BR/firefox/'
      }

      if (this.browser === 'safari') {
        location.href = 'https://support.apple.com/pt-br/HT204416'
      }

      if (this.browser === 'ie' || this.browser === 'internet explorer') {
        location.href = 'https://www.microsoft.com/pt-br/edge'
      }
    },

    checkBrowserCompatibility () {
      const { name, version, os } = this.browserInfo
      const browser = name.toLowerCase()
      const ver = version ? Number(version.split('.')[0]) : null

      if (browser === 'chrome' && ver <= 72) {
        return this.open({ browser, ver })
      }

      if (browser === 'firefox' && ver <= 64) {
        return this.open({ browser, ver })
      }

      if (browser === 'safari' && ver <= 9) {
        return this.open({ browser, ver })
      }

      if (browser === 'ie' && ver <= 10) {
        return this.open({ browser: 'internet explorer', ver })
      }

      if (os === 'opera-mini' || os === 'opera') {
        return this.open({ browser: 'not supported', ver: 0 })
      }
    },

    close () {
      this.visible = false
      this.browser = null
      this.version = null
    },

    open ({ browser, ver }) {
      this.visible = true
      this.browser = browser
      this.version = ver
    }
  },
  mounted () {
    this.checkBrowserCompatibility()
  }
}
</script>

<style lang="scss" scoped>
.browser-list {
  display: flex;
  list-style-type: none;
  margin: 0 auto;
  padding: 16px 0;
  width: 70%;

  li {
    display: flex;
    flex: 1;
    justify-content: center;
    margin-bottom: 8px;

    a {
      align-items: center;
      color: $gray-8;
      display: flex;
      flex-direction: column;
      font-weight: 600;
      text-decoration: none;
    }

    img {
      margin-bottom: 16px;
      width: 60px;
    }

    span {
      text-align: center;
    }
  }
}
</style>
